import { Droplets, Mountain, Shovel, Trees } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const SERVICES = [
  {
    id: "hydroseeding",
    icon: Droplets,
    title: "Precision Hydroseeding",
    desc: "Commercial & residential slurry application for rapid, lush lawn establishment and slope stabilization.",
    badge: "Fast Germination",
  },
  {
    id: "excavation",
    icon: Shovel,
    title: "Heavy Excavation & Site Prep",
    desc: "Foundation digging, building pad prep, utility trenching, and bulk earthmoving.",
    badge: "Laser-Guided",
  },
  {
    id: "land-clearing",
    icon: Trees,
    title: "Land Clearing & Forestry",
    desc: "Brush removal, stump grinding, timber clearing, and acreage reclamation.",
    badge: "Full Clearing",
  },
  {
    id: "grading",
    icon: Mountain,
    title: "Final Grading & Drainage",
    desc: "Swales, ditches, culvert installs, retention ponds, and erosion barrier solutions.",
    badge: "Precision Slope",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="mx-auto max-w-7xl px-4 py-24 sm:px-8 md:py-32 lg:px-16"
    >
      <SectionHeading
        overline="01 / What we do"
        title="One crew. Every scope of dirt work."
        testid="services-heading"
      />
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {SERVICES.map((s, i) => (
          <Reveal key={s.id} delay={0.1 * i}>
            <article
              data-testid={`service-card-${s.id}`}
              className="glow-card group flex h-full flex-col rounded-md border border-[#1c4431]/15 bg-[#faf6ea] p-7"
            >
              <div className="flex items-start justify-between">
                <div className="flex h-12 w-12 items-center justify-center rounded-sm border border-[#1c4431]/20 bg-[#e7efe2] text-[#1f5c3d] transition-colors duration-300 group-hover:bg-[#1f5c3d] group-hover:text-[#f6f1e3]">
                  <s.icon className="h-6 w-6" />
                </div>
                <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#2e7d4f]">
                  {s.badge}
                </span>
              </div>
              <h3 className="mt-8 font-display text-xl font-bold tracking-tight text-[#1a2e22]">
                {s.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-[#5c6b58]">
                {s.desc}
              </p>
              <span className="mt-auto pt-6 font-mono text-[10px] uppercase tracking-[0.3em] text-[#1f5c3d]/60">
                Est. East TN
              </span>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
